import React, { useState } from 'react';
import styled from 'styled-components';
import Typography from '../../common/typography/Typography';

// FAQ Card Container
const Container = styled.div`

   @media (min-width: 600px) {
    padding-left: 56px;
    padding-right: 56px;
  }
`;
const FaqCard = styled.div`

  width: 100%;
  padding: 24px 32px;

  border-radius: 12px;
  border: 1.5px solid #D6D5D9;
  background-color: #fff;
  cursor: pointer;
  transition: box-shadow 0.3s ease;
  margin-bottom: 10px;

  &:hover {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
`;

// Title of FAQ
const FaqTitle = styled.div`

  

  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
`;

// Paragraph for FAQ content
const FaqContent = styled.div`
  

  color: #1D2127;

  margin-top: 12px;
  height: ${({ isOpen }) => (isOpen ? 'auto' : '0')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  overflow: hidden;
  transition: height 0.3s ease, opacity 0.3s ease;
`;

// Icon or plus-minus for expansion
const ToggleIcon = styled.div`
  font-size: 24px;
  padding:5px;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(45deg)' : 'rotate(0)')};
  transition: transform 0.3s ease;
  color:#5B63F6;
  background:#F7F1FF
`;

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleFaq = () => {
    setIsOpen(!isOpen);
  };

  return (
    <FaqCard onClick={toggleFaq}>
      <FaqTitle>
      <Typography size="22px" weight="700">{question}</Typography> 
        <ToggleIcon isOpen={isOpen}>{isOpen ? '-' : '+'}</ToggleIcon>
      </FaqTitle>
      <FaqContent isOpen={isOpen}> <Typography size="18px" weight="500">{answer}</Typography></FaqContent>
    </FaqCard>
  );
};

// Main FAQ Component
const FAQs = () => {
  const faqData = [
    {
      question: 'What is Realverse, and how does it help improve my digital habits?',
      answer: 'Realverse is a digital wellness platform designed to help you balance your online and offline life. With features like screen time tracking, offline activity recommendations, productivity tools, and gamification, Realverse encourages healthier digital habits and supports a more fulfilling, balanced lifestyle.',
    },
    {
      question: 'How does the screen time tracking feature work?',
      answer: 'Our screen time tracking feature monitors your daily device usage and provides detailed insights. You can view reports, compare usage over time, and set goals to reduce screen time, helping you become more mindful of your digital consumption.',
    },
    {
      question: 'How do the rewards and challenges work?',
      answer: 'Realverse offers fun challenges and tasks aimed at reducing screen time or boosting productivity. As you complete these challenges, you can earn rewards like tickets or credits, which can be redeemed within the app for various activities or benefits.',
    },
    {
      question: 'Can I book offline activities directly through Realverse?',
      answer: 'Yes, you can! Realverse offers a booking system for a variety of offline activities such as workshops, events, and fitness sessions. This makes it easy to find and engage with experiences that align with your wellness goals.',
    },

  ];

  return (
    <Container>
      {faqData.map((faq, index) => (
        <FaqItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </Container>
  );
};

export default FAQs;
